import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Typography } from '@mui/material';
import { ActionButton } from '@ui/index';
import { $error, clearError } from '../../../../models/replace-employee';
import * as Styled from './styled';

export const ReplaceEmploeeErrorMessage = () => {
  const { t } = useTranslation();
  const [error] = useUnit([$error]);

  if (!error) return null;

  return (
    <Styled.Dialog onClose={() => clearError()} open={!!error}>
      <Typography variant="body1">{t('Error')}</Typography>

      <Typography variant="body2">{error?.message ?? t('DataLoadingError')}</Typography>

      <Styled.Actions>
        <ActionButton onClick={() => clearError()}>{t('close')}</ActionButton>
      </Styled.Actions>
    </Styled.Dialog>
  );
};
